exports.toNumber = function (string) {
  return Number(string.replace(/\./g, ""));
};

exports.toBoolean = function (string) {
  if (string === undefined) return false;
  return JSON.parse(string);
};
